<template>
    <page class="payment-gateway-page" :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '../generic/page/page.vue';

export default {
    components: { Page },
    data() {
        return {
            busy: false,
        };
    },
    computed: {
        tabs() {
            let tabs = [
                {
                    title: 'Payment Gateway',
                    route: `/app/payment-gateway/setup/`,
                    active: this.$route.path === `/app/payment-gateway/setup/`,
                },
                {
                    title: 'Accepted Payment Types',
                    route: `/app/payment-gateway/payment-types/`,
                    active: this.$route.path === `/app/payment-gateway/payment-types/`,
                },
                {
                    title: 'Online Payment Order',
                    route: `/app/payment-gateway/payment-order/`,
                    active: this.$route.path === `/app/payment-gateway/payment-order/`,
                },
                {
                    title: 'Automated Payments',
                    route: `/app/payment-gateway/automated-payments/`,
                    active: this.$route.path === `/app/payment-gateway/automated-payments/`,
                },
                {
                    title: 'Logs',
                    route: `/app/payment-gateway/logs/`,
                    active: this.$route.path === `/app/payment-gateway/logs/`,
                },
            ];
            return tabs;
        },
    },
    methods: {
        handleBusy(value) {
            this.busy = value;
        },
    },
};
</script>

<style lang="scss" scoped>
.payment-gateway-page {
    padding: 0 15px 50px 15px;
    :deep(.submit-buttons-wrapper) {
        position: fixed;
        bottom: 10px;
        left: 20px;
        display: flex;
        align-items: center;
    }

    :deep(.lx-page-container) {
        background-color: #edf0f6 !important;
        border-left: 1px solid #dee2e6;
        border-bottom: 1px solid #dee2e6;
        border-right: 1px solid #dee2e6;
        border-radius: 0 5px 5px 5px;
    }
    @media (max-width: 968px) {
        padding-bottom: 60px;
    }
    :deep(.payment-gateway-page-wrapper) {
        padding: 10px;
        :deep(*) {
            font-family: 'Lato', sans-serif !important;
        }
    }

    :deep(ul.nav) {
        margin-bottom: 0 !important;
        margin-left: 0 !important;
        .router-link-active {
            background-color: #edf0f6 !important;
            margin-bottom: 0 !important;
            border-color: #dee2e6 #dee2e6 #edf0f6;
        }
    }
}
</style>